export const DISCLAIMER_TEXT = 'SoftPro Documents Portal has been optimized for viewing in ' +
    'the following minimum supported versions of web browsers: ' +
    ' Apple Safari 11+, Google Chrome 61+, Mozilla FIrefox 56+, and Microsoft Edge 40+.';
